import { SET_QUESTION_OPTIONS } from "./QuestionOptionTypes";

const initialState = {
    questionOptions : []
 }
 
 const reducer = (state = initialState, action: any) => {
   switch (action.type) {
     case SET_QUESTION_OPTIONS:
       return {
         ...state,
         questionOptions: action.payload,
       }     
     default: return state
   }
 }
 
 export default reducer